import React from 'react';
import { puckFixedAspectRatioField } from '../../../media/mediaPuckFields';
import ScrollStoryBlock from './ScrollStoryBlock';
import StoryStepsField from './StoryStepsField';
import { SCROLL_STORY_STYLE_SCHEMA } from './scrollStoryStyleSchema';
import { styleDefaults } from '../../../../shared/theme/styleSchema';
import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';
import { puckThemeStyleField } from '../../../puck/fields/ThemeStyleSelectField';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { puckPrimaryColorField } from '../../../puck/fields/createPuckColorField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { puckShadowField } from '../../../puck/fields/puckShadowField';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { themedBlockProps, themedBlockResolveData, themedBlockResolveFields } from '../../../puck/themedBlocks';

const scrollStoryConfig = {
  label: 'Déroulé illustré',
  defaultProps: {
    steps: [
      { title: 'Préparation', description: '<p>Présentez le cadrage et la préparation de votre prestation.</p>', media: '' },
      { title: 'Installation', description: '<p>Expliquez la réalisation et les moyens mobilisés.</p>', media: '' },
      { title: 'Contrôle', description: '<p>Décrivez les vérifications et la livraison.</p>', media: '' },
    ],
    ...styleDefaults(SCROLL_STORY_STYLE_SCHEMA),
  },
  fields: withThemedFieldValues('scrollStory', {
    _content: puckSectionField('Étapes'),
    steps: { type: 'custom', label: 'Étapes illustrées', render: (props) => <StoryStepsField {...props} /> },
    _gallery: puckStyleGallerySectionField('Déroulé illustré'),
    themeStyleId: puckThemeStyleField('scrollStory'),
    _style: puckSectionField('Présentation'),
    visualSide: { type: 'select', label: 'Position du visuel', options: [{ label: 'À gauche', value: 'left' }, { label: 'À droite', value: 'right' }] },
    visualWidth: { type: 'select', label: 'Part du visuel', options: [{ label: '35 %', value: 35 }, { label: '45 %', value: 45 }, { label: '55 %', value: 55 }] },
    mediaAspectRatio: puckFixedAspectRatioField('Format du visuel'),
    gap: puckPxSpacingField('Écart texte / visuel'),
    transition: { type: 'select', label: 'Transition du visuel', options: [{ label: 'Fondu discret', value: 'fade' }, { label: 'Aucune', value: 'none' }] },
    accent: puckPrimaryColorField('Couleur des repères d’étapes'),
    border: puckBorderField('Cadre du visuel', { readDefaults: () => BORDERLESS_BORDER }),
    shadow: puckShadowField('Ombre du visuel'),
    textStyles: puckTextRolesField([{ key: 'title', label: 'Titre des étapes' }, { key: 'description', label: 'Explication' }, { key: 'number', label: 'Numéros d’étapes', defaultColor: 'primary' }]),
  }),
  resolveData: themedBlockResolveData('scrollStory'),
  resolveFields: themedBlockResolveFields('scrollStory'),
  render: (props) => <ScrollStoryBlock {...themedBlockProps('scrollStory', props, props.puck?.metadata)} />,
};

export default scrollStoryConfig;
